//#region ../error-codes/dist/error-codes.mjs
const RUNTIME_012 = "RUNTIME-012";

//#endregion
export { RUNTIME_012 };
//# sourceMappingURL=error-codes.js.map